// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file livesoup/v1/common.proto (package livesoup.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file livesoup/v1/common.proto.
 */
export const file_livesoup_v1_common: GenFile = /*@__PURE__*/
  fileDesc("ChhsaXZlc291cC92MS9jb21tb24ucHJvdG8SC2xpdmVzb3VwLnYxIicKBFZlYzMSCQoBeBgBIAEoAhIJCgF5GAIgASgCEgkKAXoYAyABKAIiRwoJVHJhbnNmb3JtEh4KA3BvcxgBIAEoCzIRLmxpdmVzb3VwLnYxLlZlYzMSCwoDeWF3GAIgASgCEg0KBXNjYWxlGAMgASgCQixaKmxpdmVzb3VwL3NlcnZlci9nZW4vbGl2ZXNvdXAvdjE7bGl2ZXNvdXB2MWIGcHJvdG8z");

/**
 * Local ENU metres: x east, y up, z north.
 *
 * @generated from message livesoup.v1.Vec3
 */
export type Vec3 = Message<"livesoup.v1.Vec3"> & {
  /**
   * @generated from field: float x = 1;
   */
  x: number;

  /**
   * @generated from field: float y = 2;
   */
  y: number;

  /**
   * @generated from field: float z = 3;
   */
  z: number;
};

/**
 * Describes the message livesoup.v1.Vec3.
 * Use `create(Vec3Schema)` to create a new message.
 */
export const Vec3Schema: GenMessage<Vec3> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_common, 0);

/**
 * @generated from message livesoup.v1.Transform
 */
export type Transform = Message<"livesoup.v1.Transform"> & {
  /**
   * @generated from field: livesoup.v1.Vec3 pos = 1;
   */
  pos?: Vec3 | undefined;

  /**
   * degrees, 0 = facing +z
   *
   * @generated from field: float yaw = 2;
   */
  yaw: number;

  /**
   * @generated from field: float scale = 3;
   */
  scale: number;
};

/**
 * Describes the message livesoup.v1.Transform.
 * Use `create(TransformSchema)` to create a new message.
 */
export const TransformSchema: GenMessage<Transform> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_common, 1);

